<template>
  <v-card outlined>
    <v-row no-gutters>
      <v-menu
        v-for="{ property, text, value } in dates"
        :key="property"
        offset-y
        nudge-bottom="10"
      >
        <template v-slot:activator="{ on }">
          <v-col cols="12" sm="6">
            <v-btn
              v-on="on"
              :disabled="disabled"
              text
              block
              class="caption font-weight-medium grey--text text--darken-3 text-truncate"
              max-width="100%"
            >
              {{ `${text} ${value}` }}
            </v-btn>
          </v-col>
        </template>
        <v-date-picker
          :value="value"
          @input="checkBeforeUpdate(property, $event)"
          :locale="language"
          :min="minimumDate"
          :max="maxDate"
          no-title
          color="primary"
        />
      </v-menu>
    </v-row>
  </v-card>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { mapState } from 'vuex'

export default {
  name: 'DateFilters',
  props: {
    disabled: { type: Boolean },
    initialDate: {
      type: String,
      default: () => this.minimumDate(),
      required: true
    },
    finalDate: {
      type: String,
      default: () => this.$moment().format('YYYY-MM-DD'),
      required: true
    },
    minDate: {
      type: String,
      default: '',
      required: false
    }
  },
  data() {
    return {
      maxDate: this.$moment().format('YYYY-MM-DD'),
      startOfMonth: this.$moment()
        .startOf('month')
        .format('YYYY-MM-DD')
    }
  },
  computed: {
    ...mapState({
      lang: ({ locale }) => locale,
      // creationDateOrg: ({ auth: { user } }) => user.organization.created_at,
      creationDateUser: ({ auth: { user } }) => user.created_at
    }),
    dates() {
      return [
        {
          property: 'initialDate',
          text: this.$t('dates.from'),
          value: this.initialDate
        },
        {
          property: 'finalDate',
          text: this.$t('dates.until'),
          value: this.finalDate
        }
      ]
    },
    minimumDate() {
      if (!this.minDate) {
        const creationDateOrg = this.$moment(this.creationDateUser).format(
          'YYYY-MM-DD'
        )
        const oneYearAgo = this.$moment()
          .subtract(1, 'year')
          .add(1, 'day')
          .startOf('day')
          .format('YYYY-MM-DD')
        return creationDateOrg < oneYearAgo ? creationDateOrg : oneYearAgo
      }
      return this.minDate
    },
    language() {
      const { lang } = this
      if (lang === 'es' || lang === 'es_ca') {
        return 'es-mx'
      }
      if (lang === 'en') {
        return 'en-us'
      }
      return 'pt-br'
    }
  },
  methods: {
    checkBeforeUpdate(property, value) {
      if (property === 'initialDate') {
        if (value > this.finalDate) {
          this.$toast.global.error(this.$t('dates.invalid_range'))
        } else if (value !== this.initialDate) {
          this.$emit('updateInitialDate', value)
        }
      } else if (value < this.initialDate) {
        this.$toast.global.error(this.$t('dates.invalid_range'))
      } else if (value !== this.finalDate) {
        this.$emit('updateFinalDate', value)
      }
    }
  }
}
</script>

<style></style>
